<template>
  <button
    type="button"
    class="settings-nav-item"
    :class="{ 'settings-nav-item--active': active }"
    @click="$emit('select')"
  >
    <i v-if="icon" :class="['pi', icon, 'settings-nav-item__icon']" aria-hidden="true" />
    <span class="settings-nav-item__label">{{ label }}</span>
  </button>
</template>

<script setup>
defineOptions({ name: 'SettingsNavItem' });

defineProps({
  label: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    default: ''
  },
  active: {
    type: Boolean,
    default: false
  }
});

defineEmits(['select']);
</script>

<style scoped>
.settings-nav-item {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  width: 100%;
  padding: 0.75rem 1rem;
  margin-bottom: 0.25rem;
  border: none;
  border-radius: 0.5rem;
  background: transparent;
  color: var(--crc-text-muted, var(--text-color-secondary));
  font-size: 0.875rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.settings-nav-item:hover {
  background: var(--crc-bar-bg, #fff);
  color: var(--crc-text, var(--text-color));
}

.settings-nav-item--active {
  background: var(--crc-bar-bg, #fff);
  color: var(--crc-green, #1d9e75);
  box-shadow: var(--crc-shadow-sm, 0 1px 2px rgba(0, 0, 0, 0.06));
}

.settings-nav-item__icon {
  font-size: 0.9375rem;
  flex-shrink: 0;
}

.settings-nav-item__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
